import { getDayOfWeek, timeOfWeek } from '../utils/js/time_helpers'
import { isMobile, getParameterByName } from '../utils/js/browser_helpers'

const rdmAnalytics = store => next => action => {
    let d = new Date()
    let dint = d.getDay()
    let mobile = isMobile()

    let app = getParameterByName('template') === 'basic' ? true : false

    switch (action.type) {
        case 'ANALYTIC_EVENT_PAGE':
            window.rdm.dtm.dl = {
                account: 'rogersrmisports',
                brand: 'Sportsnet',
                tags: '',
                cmsid: '3993957',
                pages: `sportsnet : ${action.naming.sport} : ${action.naming.league} : ${
                    action.naming.page
                }`,
                pageURL: action.naming.url,
                section: `sportsnet : ${action.naming.sport}`,
                subSection: `sportsnet : ${action.naming.sport} : ${action.naming.league}`,
                subSection2: `sportsnet : ${action.naming.sport} : ${action.naming.league} : ${
                    action.naming.page
                }`,
                category: action.naming.category,
                linkPage: action.naming.season || '',
                contentName: '',
                contentType: '',
                authorName: '',
                vmxC4: 'SPORTSNET',
                video: {},
                vmxEnabled: false,
                complete90percent: false,
            }
            if (window._satellite) {
                window._satellite.setVar(
                    'react_page_name',
                    `${action.naming.league || ''} ${action.naming.page || ''}`
                )
                window._satellite.track('react_page')
            }
            break

        case 'ANALYTIC_EVENT_LIVETRACKER':
            window.rdm.dtm.dl = {
                section: `sportsnet : ${action.json.details.league_short_name}livetracker`,
                subsection: `sportsnet : ${action.json.details.league_short_name}livetracker : ${
                    action.naming.section
                }`,
                dayOfWeek: getDayOfWeek(dint),
                weekendWeekday: timeOfWeek(dint),
                platform: app ? 'app' : mobile ? 'mobile' : 'desktop',
                league: action.json.details.league_short_name,
                homeTeamName: `${action.json.home_team.city} ${action.json.home_team.name}`,
                awayTeamName: `${action.json.visiting_team.city} ${action.json.visiting_team.name}`,
                gameType: action.json.details.type,
                gameId: action.json.details.id,
            }
            if (window._satellite) {
                window._satellite.track('livetracker')
            }
            break

        case 'ANALYTIC_EVENT_LIVETRACKER_ACTION':
            window.rdm.dtm.dl = {
                actionName: action.json.actionName || '',
                playerName: action.json.playerName || '',
                gameClock: action.json.gameClock || '',
            }
            if (window._satellite) {
                window._satellite.track('LTaction')
            }
            break

        case 'ANALYTIC_EVENT_LIVETRACKER_NHL_VIDEO':
            let videoObj = {
                widgetName: `${action.naming.section}`,
                position: `Pos ${action.video_position}`,
                videoTitle: action.video_title,
                pageUrl: window.location.href || document.URL || '',
            }
            window.rdm.dtm.dl.LTlinktracking = Object.keys(videoObj)
                .map(function(i) {
                    return videoObj[i]
                })
                .join(';')
            if (window._satellite) {
                window._satellite.track('videoclick')
            }
            break

        case 'ANALYTIC_EVENT_NHL_INTERMISSION_MODAL':
            if (window._satellite) {
                if (action.open) {
                    window._satellite.track('game summary view')
                }
                if (!action.open) {
                    window._satellite.setVar('close type', action.close_action)
                    window._satellite.track('game summary hide')
                }
            }
            break

        case 'ANALYTIC_EVENT_TEAM_PROFILE':
            if (window._satellite) {
                if (action.teamPage) {
                    window._satellite.setVar(
                        'react_page_name',
                        `${action.teamPage.league + ' ' + action.teamPage.pageName}`
                    )
                    window._satellite.setVar('team_name', action.teamPage.teamName)
                    window._satellite.track('react_page')
                } else if (action.redirect) {
                    window._satellite.setVar('mod_event', action.actionName)
                    if (action.link) {
                        window.rdm.dtm.dl = {
                            linkPage: action.link,
                        }
                    }
                    window._satellite.track('module_event')
                }
            }
            break

        case 'ANALYTIC_EVENT_BROADCAST_SCHEDULE':
            if (window._satellite) {
                if (action.redirect) {
                    window._satellite.setVar('mod_event', action.actionName)
                    if (action.link) {
                        window.rdm.dtm.dl = {
                            linkPage: action.link,
                        }
                    }
                    window._satellite.track('module_event')
                }
            }
            break

        default:
            return next(action)
    }
}

export default rdmAnalytics
